<template>
  <!-- Deploys / updates / deletes started from Applications, on whichever server —
       kept across the Applications pages (helpers/dockerOperations). -->
  <div v-if="entries.length" class="mb-3">
    <kvm-docker-operation
      v-for="e in entries" :key="e.serviceId + ':' + e.op.id"
      :service-id="e.serviceId" :operation="e.op"
      @done="$emit('done', { serviceId: e.serviceId, ...$event })"
      @dismiss="dismiss(e)"
    />
  </div>
</template>

<script>
import { dockerOperations, removeDockerOperation } from '@/helpers/dockerOperations'
import KvmDockerOperation from '@/views/services/hosting/kvm/KvmDockerOperation'

export default {
  name: 'ApplicationsOperations',
  components: { KvmDockerOperation },
  props: {
    // Only this server's operations (e.g. on one app's page); all when empty.
    serviceId: { type: [String, Number], default: null },
  },
  computed: {
    entries () {
      return dockerOperations.list.filter(e => this.serviceId == null || e.serviceId === String(this.serviceId))
    },
  },
  methods: {
    dismiss (e) {
      removeDockerOperation(e.serviceId, e.op.id)
    },
  },
}
</script>
